import HelpLink from 'App/HelpLink';
import { DEFAULT_LANGUAGE, HELP_LINKS_PROMOTIONS } from 'commons/constants';
import { useTranslationLanguage } from 'commons/hooks';
import { useTranslationMarketing } from 'domains/Marketing/hook';

export function PromotionHelpLink() {
  const t = useTranslationMarketing('helpLink');
  const language = useTranslationLanguage();

  return (
    <HelpLink
      title={t('promotionsAndDiscounts')}
      linkURL={
        HELP_LINKS_PROMOTIONS[language] ??
        HELP_LINKS_PROMOTIONS[DEFAULT_LANGUAGE]
      }
      icon="both"
      currentViewTracking={t('promotionsAndDiscountsTrackingName')}
      previousValue="promotions_list"
      showInMobile
    />
  );
}
